<template>
  <div id="filters">
    <v-container class="pb-0">
      <v-layout
        id="dropdown"
        class="dropdown"
        row
        wrap
        justify-center
        align-end
      >
        <v-flex xs12 sm5 md3 mx-2 v-if="areWeInMap">
          <label class="filter-label">
            Orientación Sexual e Identidad de Género
          </label>
          <v-select
            :items="['Todas', ...options['sexualIdentity']]"
            v-model="selectSexualIdentity"
            target="#dropdown"
            solo
            clearable
            flat
            label="Todas"
          >
          </v-select>
        </v-flex>
        <v-flex xs12 sm5 md3 mx-2>
          <label class="filter-label"> Entidad </label>
          <v-select
            :items="states"
            v-model="selectState"
            target="#dropdown"
            label="Todas"
            solo
            clearable
            flat
          ></v-select>
        </v-flex>
        <v-flex xs12 sm10 md3 v-if="areWeInMap">
          <label class="filter-label"> Edad </label>
          <v-select
            :items="['Todas', ...options['ageGroup']]"
            v-model="selectAgeGroup"
            target="#dropdown"
            solo
            clearable
            flat
            label="Todas"
          >
          </v-select>
        </v-flex>
      </v-layout>

      <v-layout row wrap justify-center>
        <v-flex xs12 sm5 md4 px-4>
          <label class="filter-label"> Año </label>
          <Slider />
        </v-flex>
        <v-flex xs12 sm5 md3 mx-2 v-if="areWeInMap">
          <label class="filter-label"> Características Diferenciales </label>
          <v-select
            :items="['Todas', ...options['characteristic']]"
            v-model="selectCharacteristic"
            target="#dropdown"
            solo
            clearable
            flat
            label="Todas"
          >
          </v-select>
        </v-flex>
        <v-flex xs12 sm5 md3 mx-2 v-if="checkFilter('Ocupación') && areWeInMap">
          <label class="filter-label"> Ocupación </label>
          <v-select
            :items="['Todas', ...options['occupation']]"
            v-model="selectOccupation"
            target="#dropdown"
            solo
            clearable
            flat
            label="Todas"
          >
          </v-select>
        </v-flex>
        <v-flex xs12 sm5 md3 mx-2 v-if="checkFilter('Lugar dónde se entcontró el cuerpo') && areWeInMap">
          <label class="filter-label">Lugar dónde se entcontró el cuerpo </label>
          <v-select
            :items="['Todas', ...options['whereWasFound']]"
            v-model="selectWhereWasFound"
            target="#dropdown"
            solo
            clearable
            flat
            label="Todas"
          >
          </v-select>
        </v-flex>
        <v-flex xs12 sm5 md3 mx-2 v-if="checkFilter('Tipo de arma') && areWeInMap">
          <label class="filter-label">Tipo de arma </label>
          <v-select
            :items="['Todas', ...options['weapon']]"
            v-model="selectWeapon"
            target="#dropdown"
            solo
            clearable
            flat
            label="Todas"
          >
          </v-select>
        </v-flex>
        <v-flex xs12 sm5 md3 mx-2 v-if="checkFilter('¿Hubo detenido?') && areWeInMap">
          <label class="filter-label">¿Hubo detenido? </label>
          <v-select
            :items="['Todas', ...options['yesNo']]"
            v-model="selectWasOffenderFound"
            target="#dropdown"
            solo
            clearable
            flat
            label="Todas"
          >
          </v-select>
        </v-flex>
        <v-flex xs12 sm5 md3 mx-2 v-if="checkFilter('Estado en el que se encontró el cuerpo') && areWeInMap">
          <label class="filter-label">Estado en el que se encontró el cuerpo </label>
          <v-select
            :items="['Todas', ...options['bodyState']]"
            v-model="selectBodyState"
            target="#dropdown"
            solo
            clearable
            flat
            label="Todas"
          >
          </v-select>
        </v-flex>
        <v-flex xs12 sm5 md3 mx-2 v-if="checkFilter('Indicios de violencia sexual') && areWeInMap">
          <label class="filter-label">Indicios de violencia sexual </label>
          <v-select
            :items="['Todas', ...options['yesNo']]"
            v-model="selectSexualViolence"
            target="#dropdown"
            solo
            clearable
            flat
            label="Todas"
          >
          </v-select>
        </v-flex>
        <v-flex xs12 sm5 md3 mx-2 v-if="checkFilter('Indicios de ensañamiento') && areWeInMap">
          <label class="filter-label">Indicios de ensañamiento </label>
          <v-select
            :items="['Todas', ...options['yesNo']]"
            v-model="selectTortureViolence"
            target="#dropdown"
            solo
            clearable
            flat
            label="Todas"
          >
          </v-select>
        </v-flex>
        <v-flex xs12 sm5 md2 mx-2 pt-2 v-if="areWeInMap">
          <!-- <a href=""  class="name"> Agregar o quitar filtros <i class="material-icons ">add_circle_outline </i> </a> -->
          <v-select
            class="filter-label selector more"
            label="Agregar o quitar filtros"
            append-icon="add_circle_outline"
            :items="moreFilters"
            multiple
            v-model="addFilters"
          ></v-select>
          <br />
        </v-flex>
      </v-layout>
      <hr class="line" />
    </v-container>
  </div>
</template>

<script>
import Slider from "@/components/Slider";
import $data from "@/services/data.services.js";

export default {
  name: "Filters",
  components: {
    Slider
  },
  props: {},

  data() {
    return {
      states: [
        "Aguascalientes",
        "Baja California",
        "Baja California Sur",
        "Chihuahua",
        "Colima",
        "Campeche",
        "Coahuila",
        "Chiapas",
        "Ciudad de México",
        "Durango",
        "Guerrero",
        "Guanajuato",
        "Hidalgo",
        "Jalisco",
        "Estado de México",
        "Michoacán",
        "Morelos",
        "Nayarit",
        "Nuevo León",
        "Oaxaca",
        "Puebla",
        "Querétaro",
        "Quintana Roo",
        "Sinaloa",
        "San Luis Potosí",
        "Sonora",
        "Tabasco",
        "Tlaxcala",
        "Tamaulipas",
        "Veracruz",
        "Yucatán",
        "Zacatecas"
      ],
      addFilters: [],
      moreFilters: [
        "Ocupación",
        "Lugar dónde se entcontró el cuerpo",
        "Tipo de arma",
        "¿Hubo detenido?",
        "Estado en el que se encontró el cuerpo",
        "Indicios de violencia sexual",
        "Indicios de ensañamiento"
      ],
      areWeInMap: true
    };
  },
  computed: {
    reports() {
      return this.$store.state.reports;
    },
    path() {
      return this.$route.name;
    },
    options() {
      return this.$store.state.options;
    },
    period() {
      return this.$store.state.filters.period;
    },
    selectState: {
      get() {
        // console.log('get state', this.$store.state.filters.state);
        return this.$store.state.filters.state;
      },
      set(value) {
        this.$store.commit("setStateFilter", value);
        this.update();
      }
    },
    selectCharacteristic: {
      get() {
        return this.$store.state.filters.characteristic;
      },
      set(value) {
        this.$store.commit("setCharacteristicFilter", value);
        this.update();
      }
    },
    selectAgeGroup: {
      get() {
        return this.$store.state.filters.ageGroup;
      },
      set(value) {
        this.$store.commit("setAgeGroupFilter", value);
        this.update();
      }
    },
    selectSexualIdentity: {
      get() {
        return this.$store.state.filters.sexualIdentity;
      },
      set(value) {
        this.$store.commit("setSexualIdentityFilter", value);
        this.update();
      }
    },
    selectOccupation: {
      get() {
        return this.$store.state.filters.occupation;
      },
      set(value) {
        this.$store.commit("setOccupationFilter", value);
        this.update();
      }
    },
    selectWhereWasFound: {
      get() {
        return this.$store.state.filters.whereWasFound;
      },
      set(value) {
        this.$store.commit("setWhereWasFoundFilter", value);
        this.update();
      }
    },
    selectWeapon: {
      get() {
        return this.$store.state.filters.weapon;
      },
      set(value) {
        this.$store.commit("setWeaponFilter", value);
        this.update();
      }
    },
    selectWasOffenderFound: {
      get() {
        return this.$store.state.filters.wasOffenderFound;
      },
      set(value) {
        this.$store.commit("setWasOffenderFoundFilter", value);
        this.update();
      }
    },
    selectBodyState: {
      get() {
        return this.$store.state.filters.bodyState;
      },
      set(value) {
        this.$store.commit("setBodyStateFilter", value);
        this.update();
      }
    },
    selectSexualViolence: {
      get() {
        return this.$store.state.filters.sexualViolence;
      },
      set(value) {
        this.$store.commit("setSexualViolenceFilter", value);
        this.update();
      }
    },
    selectTortureViolence: {
      get() {
        return this.$store.state.filters.tortureViolence;
      },
      set(value) {
        this.$store.commit("setTortureViolenceFilter", value);
        this.update();
      }
    }
  },
  methods: {
    update: function() {
      $data.filterData();
    },
    checkFilter(which) {
      return this.addFilters.indexOf(which) != -1;
    }
  },
  watch: {
    period: function() {
      this.update();
    },
    path: function() {
      this.areWeInMap = this.path == 'home';
      if (this.path == 'chart')
        this.$store.commit("resetFilters");
      // console.log(this.path, this.areWeInMap, 'filtros');
    }
  }
};
</script>

<style>
#filters {
  background-color: #fff;
}
.filter-label {
  text-transform: uppercase;
  font-family: "Open Sans", sans-serif;
  font-size: 10px;
  color: #414040;
  margin-bottom: 5px;
}

a.name:hover {
  color: #be3117;
}

.more .v-select__selections {
  display: none !important;
}

.v-text-field--box > .v-input__control > .v-input__slot,
.v-text-field--full-width > .v-input__control > .v-input__slot,
.v-text-field--solo > .v-input__control > .v-input__slot {
  min-height: auto !important;
  height: 40px;
  display: flex !important;
  align-items: center !important;
}

.theme--light.v-text-field--solo > .v-input__control > .v-input__slot {
  border: 1px solid #979797 !important;
  box-shadow: none;
}

.material-icons {
  vertical-align: middle;
  margin-bottom: 4px;
}

.line {
  border: auto solid #979797;
  margin-top: 15px;
  margin-bottom: 15px;
}
#filters .v-label {
  font-size: 12px;
}

.v-text-field > .v-input__control > .v-input__slot:before {
  border-style: none !important;
}

.label {
  font-size: 11px;
  color: #747474;
  font-weight: 900;
  font-family: "Open Sans", sans-serif;
}

.theme--light.v-select .v-select__selections {
  font-size: 12px;
}

.selector {
  max-width: 200px;
}
</style>
